<template>
  <div class="RealTimeinfo-Top">
    <div class="RealTimeinfoMeg">
      <div class="Infoleft">
        最新
      </div>
      <div class="InfoText">
        【2022-02-24】关于归创通桥经销商系统升级公告
      </div>
    </div>
    <div class="RealTimeinfoMeg">
      <div class="Infoleft">
        最新
      </div>
      <div class="InfoText">
        【2022-02-24】关于归创通桥经销商系统升级公告
      </div>
    </div>
    <div class="InfoRigth" @click="InfoRigthClick">更多资讯</div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    InfoRigthClick(){
      this.$router.push({
        path: JSON.parse(localStorage.getItem("MenusData")).CusWebMenus.filter(item => item.NodeID == 66)[0].Path
      })
    }
  }
}
</script>

<style lang="less">
.RealTimeinfo-Top {
  width: 100%;
  height: 72px;
  // background: linear-gradient(#d2deeb5d, #fff);
  background: url("../../../../../../../assets/channel/homePng/RealTimeinfo-Top.png") no-repeat -24px -27px;
  background-size: 104%;
  position: relative;
  top: 30px;
  display: flex;
  box-shadow: 0px 3px 5px #dfdfdf;
  border-radius: 4px;

  .RealTimeinfoMeg {
    display: inline-block;
    width: 540px;
    height: 100%;
    // border: 1px solid seagreen;

    .Infoleft {
      width: 36px;
      height: 22px;
      border: 1px solid #e71d43;
      border-radius: 1px;
      color: #e71d43;
      font-size: 12px;
      text-align: center;
      position: relative;
      top: 25px;
      left: 24px;
      line-height: 22px;
    }
    .InfoText {
      display: inline-block;
      height: 22px;
      color: #16181a;
      position: relative;
      top: 2px;
      left: 68px;
      font-size: 14px;
    }
  }
  .InfoRigth {
    width: 80px;
    height: 32px;
    border: 1px solid #00266d;
    color: #00266d;
    border-radius: 2px;
    line-height: 32px;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
    position:absolute;
    right: 0;
    transform: translate(-20%,50%);
    cursor: pointer;
  }
}
.RealTimeinfoMeg:nth-child(1)::after {
  content: "";
  width: 1px;
  height: 16px;
  float: right;
  position: relative;
  top: 5px;
  line-height: 25px;
  background: #e1e3e6;
}
</style>